/**
 * Customer-web runtime config.
 *
 * `TENANT_ID` resolves which restaurant's menu the visitor sees.
 * In production it'll come from the QR code URL or subdomain; for the
 * demo it's pinned to the `saheeh-test` Supabase tenant.
 */

import { DEMO_TENANT_ID } from './supabase';

export const TENANT_ID: string = DEMO_TENANT_ID;
